import { Navigate } from "react-router-dom";
import { AuthContextProps, useAuth } from "react-oidc-context";
import useRootPage from "app/hooks/use-root-page";
import AuthProtectorLoading from "app/guard/AuthProtectorLoading";

export default function NavigateWrapper() {
  const auth: AuthContextProps = useAuth();
  const rootPageTo: string | undefined = useRootPage(auth);

  if (rootPageTo) {
    return <Navigate to={rootPageTo} replace />;
  }

  return (<AuthProtectorLoading message="메인 화면으로 이동 중입니다." />);
}